import { Profiles } from 'types/user';

export enum APPS {
  DRILLX_SMART_OPERATIONS = 'DRILLX_SMART_OPERATIONS',
  WELL_GUARDIAN = 'WELL_GUARDIAN',
  ENERGY_EFFICIENCY = 'ENERGY_EFFICIENCY',
}

export enum APP_MODULES {
  // DRILLX SMART OPS
  HOME = 'HOME',
  GLOBAL_FEEDBACK = 'GLOBAL_FEEDBACK',
  WELL_HOME = 'WELL_HOME',
  KICK_DETECTION = 'KICK_DETECTION',
  KICK_PREDICTION = 'KICK_PREDICTION',
  STUCK_PIPE_PREDICTION = 'STUCK_PIPE_PREDICTION',
  PROGRESS_FOLLOW_UP = 'PROGRESS_FOLLOW_UP',
  LIVE_PERFORMANCE = 'LIVE_PERFORMANCE',
  PLANNING_CATALOGUE = 'PLANNING_CATALOGUE',
  PLANNING_PANEL = 'PLANNING_PANEL',
  GLOBAL_BENCHMARK = 'GLOBAL_BENCHMARK',
  EDDR = 'EDDR',
  LESSONS_LEARNT = 'LESSONS_LEARNT',
  WELL_SETTINGS = 'WELL_SETTINGS',
  WELLBORE_ADMIN = 'WELLBORE_ADMIN',
  USER_ADMIN = 'USER_ADMIN',
  WELL_GROUPS = 'WELL_GROUPS',
  ANTICOLLISION = 'ANTICOLLISION',
  DDX_PO = 'DDX_PO',
  ENERGY_EFFICIENCY = 'ENERGY_EFFICIENCY',
  DRILLX_COCKPIT = 'DRILLX_COCKPIT',
  DATA_MANAGEMENT = 'DATA_MANAGEMENT',
  LIVE_WELL_VISUALISATION = 'LIVE_WELL_VISUALISATION',
  ROP_OPTIMIZATION = 'ROP_OPTIMIZATION',
  GHOST_MODE = 'GHOST_MODE',
  ADMIN_PO = 'ADMIN_PO',
  // WELL GUARDIAN
  WELL_GUARDIAN = 'WELL_GUARDIAN',
}

export const allModules = Object.values(APP_MODULES);

export const modulesAllowedForInternal = Object.values(APP_MODULES).filter(
  module => !module.endsWith('_ADMIN') && !module.endsWith('_PO'),
);

export const modulesAllowedForExternal = modulesAllowedForInternal.filter(
  module =>
    module !== APP_MODULES.PLANNING_CATALOGUE &&
    module !== APP_MODULES.PLANNING_PANEL &&
    module !== APP_MODULES.GLOBAL_BENCHMARK &&
    module !== APP_MODULES.LESSONS_LEARNT &&
    module !== APP_MODULES.WELL_GUARDIAN,
);

export const modulesAllowedForDrillx = Object.values(APP_MODULES)
  .filter(module => module.endsWith('_ADMIN'))
  .concat(modulesAllowedForInternal);

export const modulesAllowedForReportingPartner = [APP_MODULES.EDDR, APP_MODULES.HOME];

export const allowedModules = {
  [Profiles.NO_ACCESS]: [] as APP_MODULES[],
  [Profiles.PO]: allModules,
  [Profiles.DRILLX]: modulesAllowedForDrillx,
  [Profiles.INTERNAL]: modulesAllowedForInternal,
  [Profiles.EXTERNAL]: modulesAllowedForExternal,
  [Profiles.REPORTING_PARTNER]: modulesAllowedForReportingPartner,
  [Profiles.REPORTING_PARTNER_WITH_COSTS]: modulesAllowedForReportingPartner,
};
